<template>
  <div class="wrapper" id="hari_">
    <div v-if="app" class="action_bar">
      <img class="icon" :src=" require(`../assets/${app}.png`)" v-bind:alt="`${appName}`" />
      <h2 class="mobile">{{appName[0]}}</h2>
      <h2 id="title">{{appName[1]}}</h2>
      <h2 class="mobile">{{appName[2]}}</h2>
      <i>
        <button class="btn">
          <router-link :to="{ query: {app:''}}">More Apps</router-link>
        </button>
      </i>
    </div>

    <div v-else class="action_bar">
      <img class="icon" :src=" require(`../assets/sravanotsava.png`)" />
      <h2 id="title">Śravaṇotsava</h2>
      <h2 class="mobile">- The Festival of Hearing</h2>
    </div>

    <div v-if="app" class="listContainer">
      <ul v-if="alb!=null && alb[4]>=0">
        <li class="keshav">
          <router-link :to="{ query: {app:app, l:alb[3]?lang:'', q: alb[3]}}">
            <font-awesome-icon
              style="width: 40pt; height: 40pt; padding:5pt"
              icon="arrow-circle-left"
            />
          </router-link>
          <div class="hari">
            <h1>{{alb[1]}}</h1>
            <h4>({{alb[4]}} albums, {{alb[5]}} songs)</h4>
            <span v-if="alb[4]>0">
              <i v-if="show_alb">
                <button v-on:click="toggleAudio" class="btn">Show Audios</button>
              </i>
              <i v-else>
                <button v-on:click="toggleAudio" class="btn">Show Subalbums</button>
              </i>
            </span>
          </div>
        </li>
      </ul>
      <ul v-if="!lang">
        <li v-for="a in subalbs">
          <img
            class="icon"
            v-bind:src="`https://raw.githubusercontent.com/shravanotsava/a/master/w/${a[2]}.png`"
          />
          <router-link :to="{ query: {app:app, l: a[0] }}">
            <h2>{{a[1]}}</h2>
            <i>
              <h5>({{a[4]}} albums, {{a[5]}} songs)</h5>
            </i>
          </router-link>
        </li>
      </ul>
      <ul v-else-if="subalbs.length && show_alb">
        <li v-for="a in subalbs">
          <img
            class="icon"
            v-bind:src="`https://raw.githubusercontent.com/shravanotsava/a/master/w/${a[2]}.png`"
          />
          <router-link :to="{ query: {app:app, l:lang, q: a[0] }}">
            <h2>{{a[1]}}</h2>
            <i>
              <h5>({{a[4]}} albums, {{a[5]}} songs)</h5>
            </i>
          </router-link>
        </li>
      </ul>
      <ul v-else-if="songs.length">
        <li v-for="a in songs">
          <img
            class="icon"
            v-bind:src="`https://raw.githubusercontent.com/shravanotsava/a/master/w/${a[4]}.png`"
          />
          <router-link :to="{ query: {app:app, l:lang, q: alb[0]}}">
            <h2 v-on:click="playSong(a[0])">{{a[1]}}</h2>
          </router-link>
          <i>
            <div class="dropdown">
              <button class="dropbtn">{{a[7].btn}}</button>
              <ul class="dropdown-content" v-for="(u, ind) in a[7].urls">
                <li>
                  <a :href="`https://vedabase.io/en/library/${u}`" target="_blank">{{a[7].txt[ind]}}</a>
                </li>
              </ul>
            </div>
          </i>
        </li>
      </ul>
      <img class="bg" v-else :src=" require(`../assets/${app}.png`)" />
    </div>
    <div v-else class="listContainer">
      <ul>
        <li v-for="(app, ind) in apps">
          <img class="icon" :src=" require(`../assets/${app}.png`)" v-bind:alt="`${appNames[ind]}`" />
          <router-link :to="{ query: {app:app}}">
            <h3 class="mobile">{{appNamesPrefix[ind]}}</h3>
            <h3>{{appNames[ind]}}</h3>
            <h3 class="mobile">{{appNamesMobile[ind]}}</h3>
          </router-link>
        </li>
      </ul>
      <!-- <img id="rns" src="~@/assets/rns.png" alt="His Holiness Radhanath Swami"> -->
    </div>

    <div v-if="player" class="controls">
      <img
        class="play-pause"
        :src="require(`../assets/${play_pause}.jpg`)"
        v-on:click="playPause()"
      />
      <div class="sliderContainer">
        <input
          type="range"
          min="0"
          :max="player.duration"
          class="slider"
          id="myRange"
          v-model="player.currentTime"
        />
      </div>
      <button class="progress">{{curr_time}}</button>
    </div>

    <div v-if="app&&appName[3]" class="banner">
      <img v-if="show_app_link" class="icon" :src=" require(`../assets/${app}.png`)" />
      <img v-else class="icon" style="width:20px" :src=" require(`../assets/${app}.png`)" />
      <div style="margin-top:20px" v-if="show_app_link">
        <span style="display:block">
          <h1>{{appName[1]}}</h1>
        </span>
        <a
          target="blank"
          :href="`https://play.google.com/store/apps/details?id=com.mayank.${appName[3]}`"
        >
          <button class="btn">Download Android App</button>
        </a>
      </div>
      <div v-else class="bn" v-on:click="showBanner()"></div>
      <span class="close_btn" v-if="show_app_link" v-on:click="hideBanner()">
        <font-awesome-icon
          style="width: 20pt; height: 20pt; color:gray; margin-top: -8pt"
          icon="window-close"
        />
      </span>
    </div>
  </div>
</template>

<script>
import lodash from "lodash";
import "@/bootstrap.js";
import appList from "@/appList.js";
export default {
  name: "Home",
  data() {
    return {
      apps: appList.apps,
      appNamesPrefix: appList.appNamesPrefix,
      appNames: appList.appNames,
      appNamesMobile: appList.appNamesMobile,
      pkg: appList.pkg,

      app: null,
      git: null,
      appName: [],
      alb: null,
      show_app_link: true,
      lang: null,
      song: null,
      url: "",
      player: null,
      subalbs: [],
      songs: [],
      replacements: [],
      play_pause: "play",
      curr_time: 0,
      show_alb: true
    };
  },
  mounted() {
    var elem = document.getElementById("hari_");
    console.log(elem);
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  },
  created() {
    console.log("created");
    this.app = this.$route.query.app;
    for (var i = 0; i < appList.appNamesPrefix.length; i++)
      appList.appNamesPrefix[i] = appList.appNamesPrefix[i]
        ? appList.appNamesPrefix[i]
        : "His Holiness ";
    if (this.app) {
      var ind = appList.apps.indexOf(this.app);
      this.git = appList.git[ind];
      this.appName = [
        appList.appNamesPrefix[ind],
        appList.appNames[ind],
        appList.appNamesMobile[ind],
        appList.pkg[ind]
      ];
      document.title = this.appName[1];
      var alb = this.$route.query.q;
      alb = alb && alb.length ? alb : "a";
      this.lang = this.$route.query.l;
      this.song = null == this.$route.query.a ? "" : this.$route.query.a;
      console.log("fetching projects");
      this.$http
        .get(`https://raw.githubusercontent.com/${this.git}/exp/master/h`)
        .then(
          ({ data }) => {
            this.replacements = data.split("~");
            for (var i = 0; i < this.replacements.length; i++)
              this.replacements[i] = appList.decodeUrl(this.replacements[i]);
            this.fetchProjects(this.app, alb);
          },
          err => {
            console.log(err);
          }
        );
    }
  },
  methods: {
    hideBanner() {
      document.getElementsByClassName("banner")[0].style.width = 0;
      this.show_app_link = false;
    },
    showBanner() {
      document.getElementsByClassName("banner")[0].style.width = "auto";
      this.show_app_link = true;
    },
    toggleAudio() {
      this.show_alb = !this.show_alb;
    },
    setRef(ref) {
      ref = appList.encodeUrl(ref);
      ref = ref.split(".");
      var r = { urls: [], txt: [], btn: "" };
      if (ref[0].startsWith("sb") && ref.length > 1) {
        var canto = parseInt(ref[1]);
        var ch = ref.length > 2 ? parseInt(ref[2]) : 1;
        switch (ref.length) {
          case 5:
            var s = parseInt(ref[3]);
            var e = parseInt(ref[4]);
            for (var i = s; i <= e; i++) {
              r.urls.push(ref[0] + "/" + canto + "/" + ch + "/" + i);
              r.txt.push("SB Canto " + canto + " Chapter " + ch + " Text " + i);
            }
            break;
          case 4:
            var i = parseInt(ref[3]);
            r.urls.push(ref[0] + "/" + canto + "/" + ch + "/" + i);
            r.txt.push("SB Canto " + canto + " Chapter " + ch + " Text " + i);
            break;
          case 3:
            r.urls.push(ref[0] + "/" + canto + "/" + ch);
            r.txt.push("SB Canto " + canto + " Chapter " + ch);
            break;
          case 2:
            r.urls.push(ref[0] + "/" + canto);
            r.txt.push("SB Canto " + canto);
            break;
        }
      } else if (ref[0].startsWith("cc")) {
        var ch = ref.length > 2 ? parseInt(ref[2]) : 1;
        switch (ref.length) {
          case 5:
            var s = parseInt(ref[3]);
            var e = parseInt(ref[4]);
            for (var i = s; i <= e; i++) {
              r.urls.push(ref[0] + "/" + ref[1] + "/" + ch + "/" + i);
              r.txt.push(
                "CC " +
                  ref[1].toUpperCase() +
                  " LILA Chapter " +
                  ch +
                  " Text " +
                  i
              );
            }
            break;
          case 4:
            var i = parseInt(ref[3]);
            r.urls.push(ref[0] + "/" + ref[1] + "/" + ch + "/" + i);
            r.txt.push(
              "CC " +
                ref[1].toUpperCase() +
                " LILA Chapter " +
                ch +
                " Text " +
                i
            );
            break;
          case 3:
            r.urls.push(ref[0] + "/" + ref[1] + "/" + ch);
            r.txt.push("CC " + ref[1].toUpperCase() + " LILA Chapter " + ch);
            break;
          case 2:
            r.urls.push(ref[0] + "/" + ref[1]);
            r.txt.push("CC " + ref[1].toUpperCase() + " LILA");
            break;
        }
      } else if (ref.length > 1) {
        var ch = ref.length > 2 ? parseInt(ref[1]) : 1;
        switch (ref.length) {
          case 4:
            var s = parseInt(ref[2]);
            var e = parseInt(ref[3]);
            for (var i = s; i <= e; i++) {
              r.urls.push(ref[0] + "/" + ch + "/" + i);
              r.txt.push(
                ref[0].toUpperCase() + " Chapter " + ch + " Text " + i
              );
            }
            break;
          case 3:
            var i = parseInt(ref[2]);
            r.urls.push(ref[0] + "/" + ch + "/" + i);
            r.txt.push(ref[0].toUpperCase() + " Chapter " + ch + " Text " + i);
            break;
          case 2:
            r.urls.push(ref[0] + "/" + ch);
            r.txt.push(ref[0].toUpperCase() + " Chapter " + ch);
            break;
        }
      } else {
        switch (ref[0].trim()) {
          case "bg":
          case "sb":
          case "cc":
          case "nod":
          case "noi":
          case "iso":
          case "kb":
            r.urls.push(ref[0]);
            r.txt.push(ref[0].toUpperCase());
            break;
          default:
            r.urls.push(
              `https://raw.githubusercontent.com/shravanotsava/karnamrita/master/l/${
                ref[0]
              }`
            );
            return ref;
        }
      }
      var l = r.urls.length;
      r.btn = l <= 1 ? r.txt[0] : r.txt[0] + " to " + ref[ref.length - 1];
      return r;
    },
    playPause() {
      if (this.player.paused) {
        this.player.play();
      } else {
        this.player.pause();
      }
      // setTimeout(function(){
      this.play_pause = this.player.paused ? "play" : "pause";
      // }, 300)
    },
    playSong(a1) {
      (this.url = ""), (parent = "");
      this.song = a1;
      for (var i = 0; i < this.songs.length; i++) {
        var s = this.songs[i];
        if (s[0] == this.song) {
          this.url = appList.encodeUrl(s[3]);
          parent = s[2];
          break;
        }
      }

      var i = Math.floor(appList.decode(parent) / 500);
      this.$http
        .get(
          `https://raw.githubusercontent.com/${this.git}/exp/master/b${i}/${parent}`
        )
        .then(
          ({ data }) => {
            var a = data.split("~");
            this.url = this.url.replace(
              /#/g,
              this.replacements[appList.decode(a[3]) - 1]
            );
            if (this.url.toLowerCase().endsWith(".wma")) {
              this.url = `https://raw.githubusercontent.com/shravanotsava/${this.git}/master/${this.song}.mp3`;
            } else {
              this.getUrl(a);
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    getUrl(a) {
      if (a[1].startsWith("isso;")) {
        var u = appList.encodeUrl(a[1]).replace("http://", "https://");
        this.url = u + (u.endsWith("/") ? "" : "/") + this.url;
      } else {
        var u = appList.encodeUrl(a[1]);
        var i = Math.floor(appList.decode(a[0]) / 500);
        this.$http
          .get(
            `https://raw.githubusercontent.com/${this.git}/exp/master/b${i}/${
              a[0]
            }`
          )
          .then(
            ({ data }) => {
              var a1 = data.split("~");
              u = u.replace(/#/g, this.replacements[appList.decode(a1[3]) - 1]);
              this.url =
                u +
                (u.endsWith("/") || this.url.startsWith("/") ? "" : "/") +
                this.url;
              this.getUrl(a1);
            },
            err => {
              console.log(err);
            }
          );
      }
    },
    fetchProjects(app, alb) {
      this.subalbs = [];
      this.songs = [];
      var i = Math.floor(appList.decode(alb) / 500);
      this.$http
        .get(
          `https://raw.githubusercontent.com/${this.git}/exp/master/` +
            (this.lang ? `k${appList.decode(this.lang)}/m${i}/${alb}` : "hari")
        )
        .then(
          ({ data }) => {
            var s = data.split("\n");
            var s1 = s.slice(1, s.indexOf("---"));
            var s2 = s.slice(s.indexOf("---") + 1, s.length);
            this.alb = s[0].split("~");
            this.alb.unshift(alb);
            this.alb[1] = appList.decodeUrl(this.alb[1]);
            this.alb[4] = appList.decode(this.alb[4]);
            this.alb[5] = appList.decode(this.alb[5]);
            s1.forEach(s0 => {
              var k = s0.split("~");
              k[1] = appList.decodeUrl(k[1]);
              k[4] = appList.decode(k[4]);
              k[5] = appList.decode(k[5]);
              this.subalbs.push(k);
            });
            s2.forEach(s0 => {
              var k = s0.split("~");
              k[1] = appList.decodeUrl(k[1]);
              k[7] = this.setRef(k[7]);
              this.songs.push(k);
            });
            if (this.song) this.playSong(this.song);
          },
          err => {
            console.log(err);
          }
        );
    }
  },
  watch: {
    "$route.query.app"() {
      if (this.app == this.$route.query.app) return;
      this.app = this.$route.query.app;
      this.show_app_link = true;
      if (this.app) {
        var ind = appList.apps.indexOf(this.app);
        this.git = appList.git[ind];
        this.appName = [
          appList.appNamesPrefix[ind],
          appList.appNames[ind],
          appList.appNamesMobile[ind],
          appList.pkg[ind]
        ];
        document.title = this.appName[1];
        var alb = null == this.$route.query.q ? "a" : this.$route.query.q;
        this.song = null == this.$route.query.a ? "" : this.$route.query.a;
        console.log("fetching projects");
        this.$http
          .get(`https://raw.githubusercontent.com/${this.git}/exp/master/h`)
          .then(
            ({ data }) => {
              this.replacements = data.split("~");
              for (var i = 0; i < this.replacements.length; i++)
                this.replacements[i] = appList.decodeUrl(this.replacements[i]);
            },
            err => {
              console.log(err);
            }
          );
        this.fetchProjects(this.app, alb);
      }
    },
    "$route.query.l"() {
      if (this.app && this.lang != this.$route.query.l) {
        this.lang = this.$route.query.l;
        var alb = this.$route.query.q;
        alb = alb && alb.length ? alb : "a";
        this.fetchProjects(this.app, alb);
      }
    },
    "$route.query.q"() {
      if (this.app && this.lang) {
        var alb = this.$route.query.q;
        alb = alb && alb.length ? alb : "a";
        this.fetchProjects(this.app, alb);
      }
    },
    "$route.query.a"() {
      this.song = null == this.$route.query.a ? "" : this.$route.query.a;
      if (this.song) {
        this.playSong();
      }
    },
    url() {
      if (this.url.startsWith("http")) {
        // console.log(this.url)
        if (this.player) {
          this.player.pause();
          this.player.src = this.url;
          this.playPause();
        } else {
          this.player = new Audio(this.url);
          this.playPause();
        }
        var p = this.player;
        var proj = this;
        p.addEventListener("timeupdate", function() {
          var s = Math.floor(p.currentTime);
          var m = Math.floor(s / 60);
          s = s % 60;
          var h = Math.floor(m / 60);
          m = m % 60;
          proj.curr_time = h + ":" + m + ":" + s;
        });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Home_.vue